import { useGlobalState } from "@hooks/useGlobalState";
import AppStore from "@stores/AppStore";
import { useEffect } from "react";

let initializing = false;
let defaultsSet = false;

const useAppStore = (): AppStore => {
  const [appStore] = useGlobalState("appStore");

  useEffect(() => {
    const init = async () => {
      try {
        appStore.setIsLoading(true);
        appStore.setIsInitializing(true); // TODO: redundant?

        // Load settings from localStorage on first initialization
        if (!defaultsSet) {
          defaultsSet = true;
          appStore.setDefaults();
        }

        appStore.setInitialized(true);
      } finally {
        appStore.setIsInitializing(false); // TODO: redundant?
        appStore.setIsLoading(false);
      }
    };

    if (!initializing) {
      initializing = true;
      init();
    }
  }, [appStore.isAuthenticated]);

  return appStore;
};

export default useAppStore;
